import { from, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { map, switchMap } from 'rxjs/operators';
import { Preferences } from '@capacitor/preferences';
import { StorageService } from 'src/app/services/storage/storage.service';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import constants from 'src/app/constants';
import { Platform } from '@ionic/angular';
import { Device } from '@awesome-cordova-plugins/device/ngx';
import { AppInfoService } from 'src/app/services/appInfo/app-info.service';

@Injectable({
  providedIn: 'root'
})
export class JwtInterceptorService implements HttpInterceptor {
  isBrowser: boolean;

  deviceType: string;

  constructor(
    private device: Device,
    public platform: Platform,
    private storage: StorageService,
    private appInfoService: AppInfoService
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler) : Observable<HttpEvent<any>> {
    this.isBrowser = true;
    let platformName: string = "web"; // Cordova doesn't work on browser. Manually set platform to "web"
    if (this.platform.is('cordova')) {
      this.isBrowser = false;
      platformName = this.device.platform;
    }

    let sessionTokenObservable: Observable<any> = from(this.storage.get("Session_Token"));
    if(!this.isBrowser) {
      sessionTokenObservable = from(Preferences.get({ key: 'Session_Token' }));
    }

    return sessionTokenObservable.pipe(map(token => {return token}),
    switchMap(session => {
      let token: string = session;
      if(!this.isBrowser) {
        token = session.value;
      }

      request = request.clone({
        setHeaders: {
          'Authorization': `${token}`,
          'Content-Type': 'application/json',
          'App-Version': constants.VERSION_NUMBER.toString(),
          'Platform': platformName,
          'App-ID': this.appInfoService.appID
        }
      });

      return next.handle(request); 
    }));
  }
}
